export default __webpack_public_path__ + "static/media/TRANSACTIONS_RESUME.0e409ce1.svg";